import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";



ReactDOM.render(<App />, document.getElementById("root"));
